import React from "react";
import { useShowContract } from "../../Hooks/index";
import Givetracking from "../../Components/Givetracking.jsx";
import CustomModal from "../../../../Common/Modal/CustomModal";
import Contract from "../../Components/Contract.jsx";
import { Helmet } from "react-helmet";
function Index() {
  const { modal, getData, setModal } = useShowContract();
  return (
    <>
      <Helmet>
        <title>نیکوتن | پیگیری قرارداد  </title>
      </Helmet>
      <div
        style={{ height: "100vh", width: '100vw' }}
        className="d-flex align-items-center justify-content-center "
      >
        <div className="trackinggive">
          <Givetracking getData={getData} />
          <CustomModal
            show={modal.visible}
            handleClose={() =>
              setModal(() => setModal({ ...modal, visible: false }))
            }
            header={"پیگیری قرارداد"}
            size={"xl"}
          >
            <Contract data={modal} />
          </CustomModal>
        </div>
      </div>
    </>
  );
}

export default Index;
